import * as React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import {
  auth as AuthPreset,
  history as HistoryPreset,
  match as MatchPreset,
  location as LocationPreset,
} from '../../../Util/PropTypesPreset';
import ChannelContainer from './channelContainer';
import VideoPlayer from '../../../components/VideoPlayer';
import Path from 'path';

import { withHoc } from '../../../Context/Provider';
import EPGList from './epgList';
import AuthStatus from '../../../components/authStatus';

import { Route } from 'react-router-dom';
import VODPage from './vodPage/vodPage';

const CHECK_TIME = 60 * 1000;

const propTypes = {
  auth: PropTypes.shape(AuthPreset).isRequired,
  channels: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
    load: PropTypes.bool,
  }).isRequired,
  epgs: PropTypes.shape({
    type: PropTypes.string,
    epgList: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  loadVOD: PropTypes.bool,
  vodMain: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCast: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCate: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodDetail: PropTypes.arrayOf(PropTypes.object).isRequired,
  history: PropTypes.shape(HistoryPreset).isRequired,
  match: PropTypes.shape(MatchPreset).isRequired,
  location: PropTypes.shape(LocationPreset).isRequired,
  tokenCheck: PropTypes.func,
  isTokenCheck: PropTypes.bool,
  chUpdate: PropTypes.func,
  signStatus: PropTypes.number,
  signOut: PropTypes.func,
  epgUpdate: PropTypes.func,
  vodUpdate: PropTypes.func,
  vodCastUpdate: PropTypes.func,
  vodCategoryUpdate: PropTypes.func,
  vodDetailUpdate: PropTypes.func,
};

const defaultProps = {
  auth: {},
  channels: {
    list: [],
  },
  epgs: {
    type: '',
    epgList: [],
  },
  loadVOD: false,
  vodMain: [],
  vodCast: [],
  vodCate: [],
  vodDetail: [],
};

function getBody() {
  return document.getElementsByTagName('body')[0];
}

class Player extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectChannel: null,
      videoURL: null,
      auth: {},
      channels: {},
    };
    const {
      auth,
      history,
    } = this.props;
    if (auth._id === undefined) {
      history.replace('/');
    }
    this.getToken = this.getToken.bind(this);
  }

  async componentDidMount() {
    await this.props.tokenCheck();
    const { auth, history, channels } = this.props;
    if (auth._id === undefined) {
      history.replace('/');
      return;
    }
    if (!channels.load) {
      if (auth._id !== undefined) {
        this.requestChannel();
      }
    } else {
      this.initChannel(channels);
    }
    document.addEventListener('dvr.click', this.handlerEPGItemClick);
    this.intervalAuth = setInterval(this.authCheck, CHECK_TIME);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      auth,
      loadVOD,
      channels,
      epgs,
      vodMain,
      vodCast,
      vodCate,
      vodDetail,
      isTokenCheck,
    } = this.props;
    const {
      auth: authNext,
      channels: channelsNext,
      epgs: epgsNext,
      loadVOD: loadVODNext,
      vodMain: vodMainNext,
      vodCast: vodCastNext,
      vodCate: vodCateNext,
      vodDetail: vodDetailNext,
      isTokenCheck: isTokenCheckNext,
    } = nextProps;
    if (!isTokenCheckNext) {
      this.props.history.replace('/expired');
    }
    if (
      this.state.selectChannel === null &&
      nextProps.channels.list.length >= 1 &&
      nextProps.channels.load
    ) {
      this.initChannel(nextProps.channels);
      return true;
    } else if (
      this.state.selectChannel !== nextState.selectChannel ||
      this.props.location !== nextProps.location ||
      auth !== authNext ||
      channels !== channelsNext ||
      epgs !== epgsNext ||
      loadVOD !== loadVODNext ||
      vodMain !== vodMainNext ||
      vodCast !== vodCastNext ||
      vodCate !== vodCateNext ||
      vodDetail !== vodDetailNext ||
      isTokenCheck !== isTokenCheckNext
    ) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    const body = getBody();
    if (body.classList.contains('player')) {
      body.removeAttribute('class', 'player');
    }
    document.removeEventListener('dvr.click', this.handlerEPGItemClick);

    if (this.intervalAuth) {
      clearInterval(this.intervalAuth);
    }
  }

  initChannel = (Channels) => {
    const chGroup = Channels.list[0].list;
    if (chGroup.length >= 1) {
      const selectChannel = chGroup[0];
      const cookie = Cookies.get('TIME_AUTH')
      this.setState({
        selectChannel,
        videoURL: `${selectChannel.url}/${selectChannel.ch}/${
          selectChannel.ext
        }?token=${cookie}`,
      });
    }
  }

  authCheck = () => {
    this.props.tokenCheck();
  }

  isEPGVisible = () => {
    const { location } = this.props;
    return /^\/(player)\/(epg)\/[0-9]+/.test(location.pathname);
  }

  getToken() {
    const cookie = Cookies.get('TIME_AUTH');
    if (!cookie || !cookie.replace) {
      return cookie
    }
    const re = /"/gi;
    const token = encodeURIComponent(cookie.replace(re, "'"));
    return token;
  }

  requestChannel = () => {
    const { chUpdate, signStatus } = this.props;
    chUpdate(signStatus);
  }

  handlerChannelSelect = (selectChannel, videoURL) => {
    this.setState({ selectChannel, videoURL }, () => {
      if (this.isEPGVisible()) {
        this.props.history.replace(this.props.match.url);
      }
    });
  }

  handlerEPGItemClick = (e) => {
    const { detail } = e;
    this.props.history.replace('/player');
    this.setState({ videoURL: detail.videoURL });
  }

  handlerEPGSelect = (selectChannel, epgNumber) => {
    const { match, history } = this.props;

    const { url, ch, ext } = selectChannel;
    this.setState(
      {
        selectChannel,
        videoURL: `${url}/${ch}/${ext}`,
      },
      () => {
        history.replace(Path.join(match.url, 'epg', epgNumber));
      },
    );
  }

  handlerVODSelect = (groupTitle: string) => {
    const { history } = this.props;
    if (groupTitle === 'VOD') {
      history.replace('/player/vod')
    } else {
      history.replace('/player')
    }
  }

  handlerVODCastSelect = (cast: string) => {
    const { history } = this.props
    history.replace(`/player/vod/${cast}`)
  }

  handlerVODCatSelect = (cat: string) => {
    const { history, location } = this.props
    history.replace(`${location.pathname}?cate=${cat}`)
  }

  handlerVODProgramSelect = (program: string) => {
    const { history, location } = this.props
    history.replace(`${location.pathname}?program=${program.program}`)
  }

  render() {
    const { selectChannel, videoURL } = this.state;
    const {
      auth,
      channels,
      epgs,
      loadVOD,
      vodMain,
      vodCast,
      vodCate,
      vodDetail,
      signOut,
      epgUpdate,
      vodUpdate,
      vodCastUpdate,
      vodCategoryUpdate,
      vodDetailUpdate,
      match,
      location,
    } = this.props;
    const cookie = this.getToken();
    const isEPGPath = /\/epg\//.test(location.pathname);
    const isVODPath = /\/vod/.test(location.pathname);
    return (
      <div id="page--main" className="page--fragment">
        <div className="container">
          {selectChannel !== null && (
            <React.Fragment>
              <ChannelContainer
                Channels={channels}
                select={selectChannel}
                onClick={this.handlerChannelSelect}
                onClickVOD={this.handlerVODSelect}
                onClickEPG={this.handlerEPGSelect}
                tokenCheck={this.props.tokenCheck}
              />
              <Route
                exact
                path={`${match.path}/epg/:id`}
                render={() => {
                  return (
                    <EPGList
                      auth={auth}
                      epgs={epgs}
                      channel={selectChannel}
                      channelList={channels}
                      signOut={signOut}
                      epgUpdate={epgUpdate}
                    />
                  );
                }}
              />
            </React.Fragment>
          )}
          {!isEPGPath && videoURL && !isVODPath && (
            <div id="video-container">
              <div className="flex--container">
                <div className="video--container--body">
                <VideoPlayer src={`${videoURL}`} controls />
                </div>
              </div>
              <AuthStatus
                auth={this.props.auth}
                onClickSignOut={this.props.signOut}
                history={this.props.history}
              />
            </div>
          )}
        </div>
        {isVODPath && (
          <VODPage
            onClickCast={this.handlerVODCastSelect}
            onClickProgram={this.handlerVODProgramSelect}
            onClickCategory={this.handlerVODCatSelect}
            auth={auth}
            vodUpdate={vodUpdate}
            vodCastUpdate={vodCastUpdate}
            vodCategoryUpdate={vodCategoryUpdate}
            vodDetailUpdate={vodDetailUpdate}
            loadVOD={loadVOD}
            vodMain={vodMain}
            vodCast={vodCast}
            vodCate={vodCate}
            vodDetail={vodDetail}
            match={match}
            location={location}
          />
        )}
      </div>
    );
  }
}

Player.propTypes = propTypes;
Player.defaultProps = defaultProps;

export default withHoc(Player);
